export const detectionsConstants = {
  LOADING_LOTS: '[Detections] Loading lots',
  LOADING_LOTS_SUCCESS: '[Detections] Loading lots success ',
  LOADING_LOTS_FAILURE: '[Detections] Loading lots failure',
  UPDATING_LOTS: '[Detections] Updating lots',
  UPDATING_LOTS_SUCCESS: '[Detections] Updating lots success',
  UPDATING_LOTS_FAILURE: '[Detections] Updating lots failure',

  LOADING_DETECTIONS: '[Detections] Loading detections',
  LOADING_DETECTIONS_SUCCESS: '[Detections] Loading detections success',
  LOADING_DETECTIONS_FAILURE: '[Detections] Loading detections failure',

  ASSIGNING_LOT: '[Detections] Assigning detections to lot',
  ASSIGN_LOT_SUCCESS: '[Detections] Assign detections to lot success',
  ASSIGN_LOT_FAILURE: '[Detections] Assign detections to lot failure',

  UPDATING_LOT_PERSON: '[Detections] Updating lot person',
  UPDATING_LOT_PERSON_SUCCESS: '[Detections] Updating lot person success',
  UPDATING_LOT_PERSON_FAILURE: '[Detections] Updating lot person failure',

  RESET_ALL: '[Detections] Reset all',

  CHANGE_RESOLVED_STATUS: '[Detections] Change resolved status',
  CHANGE_RESOLVED_STATUS_SUCCESS: '[Detections] Change resolved status success',
  CHANGE_RESOLVED_STATUS_FAILURE: '[Detections] Change resolved status failure'
}
